import type {FunctionComponent} from 'react';
import {LandingSection} from '@tempo/landing';
import {Box} from '@tempo/core';
import {Image} from '@app/components/Image';

export const FeatureMusicImage: FunctionComponent = () => {
	return (
		<Box display={{base: 'none', sm: 'block'}}>
			<LandingSection isContained>
				<Image
					alt=""
					src="ca8cbb70c0021d656e7b14d7a4ffe672.jpg"
					aspectRatio="2300/1530"
				/>
			</LandingSection>
		</Box>
	);
};
